export default __webpack_public_path__ + "static/media/arrow-dapp.3488a244.svg";